import i18next from "i18next";

export const getTypeChips = () => [
  {
    text: i18next.t("recommender.chips.all"),
    value: "all",
    clickable: true,
  },
  {
    text: i18next.t("recommender.chips.fonds"),
    value: "MUTUAL_FUND",
    clickable: true,
  },
  {
    text: i18next.t("recommender.chips.etf"),
    value: "ETF",
    clickable: true,
  },
];
